///////////////////////////////:
$(function() {
    /*
    wow = new WOW(
      {
        animateClass: 'animated',
        offset:       100,
        callback:     function(box) {
          console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
        }
      }
    );
    wow.init();
    */
    //$('[data-toggle="tooltip"]').tooltip();

    //$('[data-toggle="popover"]').popover();

    $.ajaxSetup({
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
    });


    $(".lightgallery").lightGallery({
        selector: '.item',
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        loadVimeoThumbnail: true,
        vimeoThumbSize: 'thumbnail_medium',
        zoom:false
    });

    //$(".lightgallery-deplacement").lightGallery();

    $('table').each(function(){
       $(this).find('td').css('padding',$(this).attr('cellpadding')+'px');
       $(this).find('td').css('margin',$(this).attr('cellspacing')+'px');
    });

    $('[data-link]').on('click', function(e) {
        e.preventDefault();
        if ($(this).data('target')=="new") {
            var win = window.open($(this).data('link'), '_blank');
              win.focus();
        }
        else { location.href = $(this).data('link'); }
    });

    $('#navbar-main-menu').on('click',function(){
        if($(this).find('span').hasClass('fa')){
            $(this).find('span').removeAttr('class').addClass('fal fa-times');
        } else {
            $(this).find('span').removeAttr('class').addClass('fa fa-bars');
        }
    });

    /*
    $('.navbar-toggler').on('click',function(){
        $(this).find('.fa, .fal').toggleClass('fa').toggleClass('fal').toggleClass('fa-bars').toggleClass('fa-times');
    });
    */

    $(document.body).click(function(e) {
        var div_cliquable = $('#navbar-main-menu');
        if(!$(e.target).is(div_cliquable) && div_cliquable.parent().hasClass('show')) {
            div_cliquable.find('span').removeAttr('class').addClass('fa fa-bars');
        }
    });

    //$('.same-height').matchHeight();

    /*
    $('#hideseeksearch').hideseek({
        list: '.hideseek-list',
        highlight: true,
		ignore_accents: true
    });
    */
    /*
    $('.grid').colcade({
        columns: '.grid-col',
        items: '.grid-item'
    });
    */

    $( window ).resize(function() {
        if ($('body').height() < $(window).height()) {$('#footer-new').addClass('footer-bottom');}
    });
    if ($('body').height() < $(window).height()) {$('#footer-new').addClass('footer-bottom');}
});

$('#preloader').fadeOut(1000, function() {
    $('#preloader').html('');
});

// HEADER MASQUÉ PAR DÉFAUT S'AFFICHE AU SCROLL
$(window).scroll(function() {
    var value = jQuery(this).scrollTop();
    if ( value > 86 ) {
        $("#remonte").addClass('active');
        $("body").addClass('navbar-shrink');


        //$("body.desktop").css('padding-top','140px');
    } else {
        $("#remonte").removeClass('active');
        $("body").removeClass('navbar-shrink');

        //$("body.desktop").css('padding-top','86px');
    }
    if ( value > 0 ) {
        $('body').addClass('title-shrink');
    } else {
        $('body').removeClass('title-shrink');
    }
});

//if ($('body').height() <= $(window).height()) {
    //$("#nav-main").addClass('navbar-shrink');
    //$("body:not(.desktop)").css('padding-top','80px');
    //$("body.desktop").css('padding-top','140px');
//}

$('.remonte').on('click',function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, 500);
});

$(window).on("load",function(){
    $(".content").mCustomScrollbar();
});

$(document).ready(function(){
    $("#btnViewSearch").click(function(event){
        event.preventDefault();
        $("#navBlocSearch").toggleClass("d-lg-none");
    });


    $(".js-scroll-to").click(function(e) {
        e.preventDefault();
        var aid = $(this).attr("href");
        $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
    });

    //Module SE DEPLACER
    $('#form_line').change(function() {
        var selected_line = $(this).val();
        $.get('/ajax/module/cam/sens-ligne/'+selected_line,function(data){
            $('#bloc_form_sens').html(data);
            $('.selectpicker').selectpicker();
        });

        //Efface les arrets de bus si on change de ligne
        $('#bloc_form_arret .block_disabled').addClass('disabled');
        $("#form_arret").prop("selectedIndex", 0).find('option').not(':first').remove();
        //Desactive le button submit
        $('#form_deplacer').find('.btn-cam').attr('disabled');
        //Efface les horaires si change de ligne
        $('#result-bloc-horaire').find('.bloc-horaire').remove();

        //Changement de carte au choix de la ligne
        if($('#result-bloc-deplacement').length){
            $('.lightgallery-deplacement').removeClass('d-flex').addClass('d-none');
            $('#plan-ligne-'+selected_line).addClass('d-flex');
        }

        //Changement du lien temps reel
        $('#btn-temps-reel').attr('href','https://webapp.cam.mc/app/fr/linestops.php?route_id='+selected_line);
    });

    $(document).on('change', '#form_sens', function() {
        var selected_ligne = $('#form_line').val();
        var selected_direction = $('#form_sens').val();
        $.get('/ajax/module/cam/arrets-ligne/'+selected_ligne+'/'+selected_direction,function(data){
            $('#bloc_form_arret').html(data);
            $('.selectpicker').selectpicker();
        });
        alert('https://webapp.cam.mc/app/fr/stopview.php?route_id='+ selected_line +'&stop_id=1&direction='+ selected_direction);
        $('#btn-temps-reel').removeAttr('href').attr('href','https://webapp.cam.mc/app/fr/stopview.php?route_id='+ selected_line +'&stop_id=1&direction='+ selected_direction);
    });

    $(document).on('change', '#form_arret', function() {
        var selected_ligne = $('#form_line').val();
        var selected_direction = $('#form_sens').val();
        var selected_arret = $('#form_arret').val();
        $('#form_deplacer').find('.btn-cam').removeAttr('disabled');

        $('#btn-temps-reel').attr('href','https://webapp.cam.mc/app/fr/stopview.php?route_id='+ selected_ligne +'&stop_id='+ selected_arret +'&direction='+selected_direction);
    });


    $('#responsive-lightslider').lightSlider({
        item:4,
        loop:false,
        slideMove:2,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:600,
        responsive : [
            {
                breakpoint:800,
                settings: {
                    item:3,
                    slideMove:1,
                    slideMargin:6,
                  }
            },
            {
                breakpoint:480,
                settings: {
                    item:2,
                    slideMove:1
                  }
            }
        ]
    });


    /*
    $(document).on('change', '#form_deplacer select', function() {
    //$('#form_deplacer select').live('change',function() {
        var form_deplacement = $("#form_deplacer").serialize();
        //console.log(form_deplacement);

        $.ajax({
            type: 'POST',
            processData: true,
            url: '/ajax/deplacement',
            dataType: 'html',
            data:form_deplacement,
            success: function(data){
                //console.log(data);
                var form_dynamic_deplacement = $('#form-dynamic-deplacement');
                //form_dynamic_deplacement.remove();
                form_dynamic_deplacement.html(data);
            }
        });
    });*/


});
